import { Component, Input } from '@angular/core';
import { AutoPropertyDamage } from '../../../../../models/api/view/claim/details/auto/auto-property-damage';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-property-au',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-12 tw-py-8">
      <app-detail-panel [dataSource]="propertyData" class="tw-basis-1/3">
        <app-detail-item
          label="property description"
          name="propertyDescription"
        />
        <app-detail-item label="insured" name="insured" />
        <app-detail-item label="agency" name="agency" />
        <app-detail-item label="policy" name="policy" />
      </app-detail-panel>

      <app-detail-panel [dataSource]="propertyData" class="tw-basis-1/3">
        <app-detail-item label="damage description" name="damageDescription" />
        <app-detail-item label="estimate" name="estimate" format="c" />
        <app-detail-item label="property location" name="propertyLocation" />
      </app-detail-panel>
    </div>
  `,
  styles: ``,
})
export class PropertyAuComponent extends BaseComponent {
  @Input() propertyDamage: AutoPropertyDamage;

  get propertyData(): AutoPropertyDamage {
    return this.propertyDamage || {};
  }
}
